<template>
  <div class="upload-container">
    <p>Please enter your email first:</p>
    <el-input
      ref="you_email"
      v-model="your_email"
      clearable
      autocomplete="off"
    />
    <hr>
    <el-upload
      v-if="is_email_valid"
      ref="upload"
      multiple
      class="upload"
      action="/upload_file_to_storage"
      :data="{current_path: '/FileTransfer/' + your_email }"
      :headers="{ 'X-CSRF-TOKEN': csfr}"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-success="success_upload"
      :on-error="error_upload"
      list-type="text"
      style="display: inline;"
    >
      <el-button
        size="mini"
        type="primary"
      >
        Click to upload files
      </el-button>
    </el-upload>
    <el-progress
      v-if="uploading"
      :percentage="progress"
      status="active"
      style="margin-top: 20px;"
    />
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'TransferFileUpload',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fileList: [],
      email: '',
      downloading: false,
      downloadLink: '',
      uploading: false,
      progress: 0,
      your_email: this.value,
      csfr: Vue.http.headers.common['X-CSRF-Token'],
    };
  },
  computed: {
    is_email_valid() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(this.your_email);
    }
  },
  watch: {
    your_email(val) {
      this.$emit('input', val); // notify parent
    },
    value(val) {
      this.your_email = val; // update if parent changes it
    }
  },
  methods: {
    success_upload() {
      console.log(this.current_path);
    },
    error_upload(err) {
      let msg = JSON.parse(err.message);
      this.$message({
        message: msg.notice,
        type: 'error'
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      let preview_url = String(file).replace('get_file', 'preview_file');
      let d = encodeURIComponent('&');
      let h = encodeURIComponent('#');
      preview_url  = String(preview_url).replace(/&/g, d).replace(/#/g, h);
      window.location = encodeURI(preview_url);
    },
  },
};
</script>

<style scoped>
.upload-container {
  padding: 2px;
  max-width: 500px;
  margin: auto;
}
</style>
